import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../components/react/button';

const GiftCardPromoElement = ({
  backgroundImage,
  title,
  copy,
  ctaLabel,
  ctaLink,
  imageSrc,
  imageAltText
}) => {
  return (
    <div className="container promo-element">
      <div
        className="promo-element__inner"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div>
          {title && <h2 className="promo-element__title">{title}</h2>}
          {copy && (
            <p
              className="promo-element__copy"
              dangerouslySetInnerHTML={{ __html: copy }}
            />
          )}
          {ctaLabel && ctaLink && (
            <Button
              label={ctaLabel}
              btnClassName="secondary"
              type="link"
              href={ctaLink}
            />
          )}
        </div>
        {imageSrc && (
          <div>
            <div className="promo-element__image">
              <img src={imageSrc} alt={imageAltText} className="img--cover" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

GiftCardPromoElement.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
  ctaLink: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  imageAltText: PropTypes.string.isRequired
};

export default React.memo(GiftCardPromoElement);
